import { StyleSheet } from 'react-native';

/**
 * For root views/wrappers
 */
export const globalStyles = StyleSheet.create({
  wrapper: {
    flex: 1,
  },
});
